'use client'

import { createContext, useContext } from 'react'
import { pt } from '@/lib/i18n/locales/pt'
import { t as rawT, plural as rawPlural, type Vars } from '@/lib/i18n/core'
import type { Messages, TranslationKey } from '@/lib/i18n/types'

const I18nContext = createContext<Messages>(pt)

export function I18nProvider({ children, messages = pt }: { children: React.ReactNode; messages?: Messages }) {
  return <I18nContext value={messages}>{children}</I18nContext>
}

export function useTranslations() {
  const messages = useContext(I18nContext)
  return {
    t: (key: TranslationKey, vars?: Vars) => rawT(messages, key, vars),
    plural: (count: number, keys: { one: TranslationKey; other: TranslationKey }, vars?: Vars) =>
      rawPlural(messages, count, keys, vars),
  }
}
